import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\ConnectController::index
* @see app/Http/Controllers/Teacher/ConnectController.php:20
* @route '/teacher/connect'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/connect',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\ConnectController::index
* @see app/Http/Controllers/Teacher/ConnectController.php:20
* @route '/teacher/connect'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ConnectController::index
* @see app/Http/Controllers/Teacher/ConnectController.php:20
* @route '/teacher/connect'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\ConnectController::index
* @see app/Http/Controllers/Teacher/ConnectController.php:20
* @route '/teacher/connect'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\ConnectController::onboard
* @see app/Http/Controllers/Teacher/ConnectController.php:53
* @route '/teacher/connect/onboard'
*/
export const onboard = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: onboard.url(options),
    method: 'post',
})

onboard.definition = {
    methods: ["post"],
    url: '/teacher/connect/onboard',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\ConnectController::onboard
* @see app/Http/Controllers/Teacher/ConnectController.php:53
* @route '/teacher/connect/onboard'
*/
onboard.url = (options?: RouteQueryOptions) => {
    return onboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ConnectController::onboard
* @see app/Http/Controllers/Teacher/ConnectController.php:53
* @route '/teacher/connect/onboard'
*/
onboard.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: onboard.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\ConnectController::returnMethod
* @see app/Http/Controllers/Teacher/ConnectController.php:73
* @route '/teacher/connect/return'
*/
export const returnMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returnMethod.url(options),
    method: 'get',
})

returnMethod.definition = {
    methods: ["get","head"],
    url: '/teacher/connect/return',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\ConnectController::returnMethod
* @see app/Http/Controllers/Teacher/ConnectController.php:73
* @route '/teacher/connect/return'
*/
returnMethod.url = (options?: RouteQueryOptions) => {
    return returnMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ConnectController::returnMethod
* @see app/Http/Controllers/Teacher/ConnectController.php:73
* @route '/teacher/connect/return'
*/
returnMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: returnMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\ConnectController::returnMethod
* @see app/Http/Controllers/Teacher/ConnectController.php:73
* @route '/teacher/connect/return'
*/
returnMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: returnMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\ConnectController::refresh
* @see app/Http/Controllers/Teacher/ConnectController.php:96
* @route '/teacher/connect/refresh'
*/
export const refresh = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: refresh.url(options),
    method: 'get',
})

refresh.definition = {
    methods: ["get","head"],
    url: '/teacher/connect/refresh',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\ConnectController::refresh
* @see app/Http/Controllers/Teacher/ConnectController.php:96
* @route '/teacher/connect/refresh'
*/
refresh.url = (options?: RouteQueryOptions) => {
    return refresh.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ConnectController::refresh
* @see app/Http/Controllers/Teacher/ConnectController.php:96
* @route '/teacher/connect/refresh'
*/
refresh.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: refresh.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\ConnectController::refresh
* @see app/Http/Controllers/Teacher/ConnectController.php:96
* @route '/teacher/connect/refresh'
*/
refresh.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: refresh.url(options),
    method: 'head',
})

const connect = {
    index: Object.assign(index, index),
    onboard: Object.assign(onboard, onboard),
    return: Object.assign(returnMethod, returnMethod),
    refresh: Object.assign(refresh, refresh),
}

export default connect